import React from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import AddCustomer from '../../components/customer_comp/AddCustomer';

/**
 * AddCustomerPage — Page wrapper
 * Bootstrap 5 layout. GTSS colors via gtss- utility classes.
 * Title switches between "Add Customer" and "Edit Customer"
 * based on whether location.state contains a customer record.
 */
const AddCustomerPage = () => {
    const { state } = useLocation();

    // Match the same id-based detection used inside AddCustomer component
    const isEditMode = !!(state?.id ?? null);
    const pageTitle = isEditMode ? 'Edit Customer' : 'Add Customer';

    return (
        <div className="d-flex flex-column h-100 overflow-hidden py-2 py-md-3 px-0 px-md-5">
            <div className="flex-shrink-0">
                <PageHeader title={pageTitle} />
            </div>
            <div className="flex-grow-1 overflow-auto d-flex flex-column">
                <AddCustomer />
            </div>
        </div>
    );
};

export default AddCustomerPage;